import type {
  EventAdvancedConfigVisibilityRule,
  EventAdvancedConfigVisibilityRuleFormValues,
} from "../../../models/rulesEventAdvancedConfig";
import type { AdminRulesColumnDef, AdminRulesInlineFormField, AdminRulesTabConfig } from "../types";

const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

const formatConditionLabel = (enabled: boolean): string => (enabled ? "Sí" : "No");

export const eventAdvancedConfigTabConfig: AdminRulesTabConfig<
  EventAdvancedConfigVisibilityRule,
  EventAdvancedConfigVisibilityRuleFormValues
> = {
  category: "event-advanced-config",
  label: "Supresión y valoración",
  enabled: true,
  scopeFields: {
    eventTypeRequired: false,
    tenantRequired: true,
    tenantPersistence: "required-uuid",
  },
  customColumns: [
    {
      field: "requiresRecurrent",
      header: "Solo recurrentes",
      body: (row) => formatConditionLabel(row.requiresRecurrent),
      sortable: true,
    },
  ] satisfies AdminRulesColumnDef<EventAdvancedConfigVisibilityRule>[],
  inlineFormFields: [
    {
      name: "requiresRecurrent",
      label: "Solo eventos recurrentes",
      type: "switch",
    },
  ] satisfies AdminRulesInlineFormField<EventAdvancedConfigVisibilityRuleFormValues>[],
  getEmptyFormValues: () => ({
    eventTypeId: null,
    eventSubTypeId: null,
    tenantId: undefined,
    requiresRecurrent: true,
    active: true,
  }),
  mapRowToFormValues: (row) => ({
    eventTypeId: row.eventTypeId,
    eventSubTypeId: row.eventSubTypeId ?? null,
    tenantId: row.tenantId,
    requiresRecurrent: row.requiresRecurrent,
    active: row.active,
  }),
  mapFormToCreatePayload: (values) => ({
    tenantId: String(values.tenantId),
    eventTypeId: values.eventTypeId ?? null,
    eventSubTypeId: values.eventTypeId == null ? null : values.eventSubTypeId ?? null,
    requiresRecurrent: Boolean(values.requiresRecurrent),
    active: Boolean(values.active),
  }),
  mapFormToUpdatePayload: (values, rowId) => ({
    id: rowId,
    tenantId: String(values.tenantId),
    eventTypeId: values.eventTypeId ?? null,
    eventSubTypeId: values.eventTypeId == null ? null : values.eventSubTypeId ?? null,
    requiresRecurrent: Boolean(values.requiresRecurrent),
    active: Boolean(values.active),
  }),
  validateForm: (values) => {
    if (!values.tenantId || !UUID_PATTERN.test(values.tenantId)) {
      return "Seleccioná un tenant.";
    }
    if (values.eventSubTypeId != null && values.eventTypeId == null) {
      return "Para elegir un subtipo primero seleccioná un tipo de evento.";
    }
    return null;
  },
};
